import AppProvider from '@app/app-provider.tsx';
import { HelmetProvider } from 'react-helmet-async';
import { ApolloClientProvider } from './context/ApolloClientContext';
import { Root } from './routes/Root';
import './styles/tailwind.css';

interface TracifyPurchaseOptions {
  amount: string;
  orderId: string;
  currency: 'EUR';
  email?: string;
  dateTime?: Date;
}

declare global {
  interface Window {
    UC_UI: {
      getServicesBaseInfo: () => Array<Record<string, any>>;
      acceptService: (serviceId: string) => void;
      showSecondLayer: () => void;
    };

    cello: any;
    Cello: any;
  }
}

function App() {
  return (
    <ApolloClientProvider>
      <AppProvider>
        <HelmetProvider>
          <Root />
        </HelmetProvider>
      </AppProvider>
    </ApolloClientProvider>
  );
}

export default App;
